import React, { useMemo } from "react";

import TransactionTable from "./TransactionTable";
import { groupTransactions } from "../transactionGroups";

const TransactionList = ({ items, grouped = true, onSelect }) => {
  const sections = useMemo(
    () => (grouped ? groupTransactions(items) : [{ title: null, items }]),
    [items, grouped]
  );

  return (
    <div className="fin-sections">
      {sections.map((section) => (
        <section className="fin-section" key={section.title || "all"}>
          {section.title && <h4 className="fin-section-title">{section.title}</h4>}

          <TransactionTable items={section.items} onSelect={onSelect} />
        </section>
      ))}
    </div>
  );
};

export default TransactionList;
